import React, { useEffect, useState } from 'react';
// import Main from '../components/layout/Main';
import axios from 'axios';
import { Button, DatePicker, Input, Radio, Tooltip, message } from 'antd';
import { useLocation } from 'react-router-dom';
import AdminProfile from './AdminProfile';
import { CSVLink } from 'react-csv';
import NewTransactionTable from './NewTransactionTable';
import Model from './Model';
import { format } from 'date-fns';

const { Search } = Input;
const { RangePicker } = DatePicker;

function LogsTable(props) {
    const { userName, formSubmitted, FilterValue } = props;
    const [totalPages, setTotalPages] = useState(0);
    const [page, setPage] = useState(1);
    const [size, setSize] = useState(50);
    const [data, setData] = useState([]);
    const [data1, setData1] = useState([]);
    const [statusFilterValue, setStatusFilterValue] = useState("TRADE");
    const [levelFilter, setLevelFilter] = useState(null);
    const [UsernameFilter, setUsernameFilter] = useState(null);
    const [dateFilter, setdateFilter] = useState(null);
    const [TransidFilter, setTransidFilter] = useState(null);
    const location = useLocation();
    const { profile } = AdminProfile()
    const [profileAvatar, setProfileAvatar] = useState(profile?.Adminname);
    const [gatewayFilter, setGatewayFilter] = useState(null);
    const [assetsFilter, setAssetsFilter] = useState(null);
    const [searchType, setSearchType] = useState(1);
    const [placeholder, setPlaceholder] = useState('Search Username...');
    const jwt = localStorage.getItem('jwt');
    const [filter, setFilter] = useState("SPOT");

    const handleFilterClick = (filterType) => {
        setFilter(filterType);
    };


    useEffect(() => {
        setProfileAvatar(profile?.Adminname);
    }, [profile]);

    const handleStatusFilter = (pack) => {
        setStatusFilterValue(pack);
    };

    const ViewTotalLevel = (statusFilterValue, usernameValue, form_by, datefilter, exchange_type) => {
        const jwt = localStorage.getItem('jwt');

        const postData = {
            jwt: jwt,
            page_no: page,
            page_size: size,
        };

        if (location.pathname === '/UpdateUser' || location.pathname === '/UpdateUsers' || location.pathname === '/dashboard/activeuser' || location.pathname === '/dashboard/activeuser') {
            postData.username = [userName];
        }

        if (datefilter !== null && datefilter.length > 0) {
            postData.date = datefilter;
        }


        if (form_by !== null && form_by !== undefined) {
            postData.by = [form_by]
        }
        if (usernameValue !== null && usernameValue !== undefined) {
            if (/^\d+$/.test(usernameValue)) {
                postData.transid = [usernameValue];
            } else {
                postData.username = [usernameValue];
            }
        }

        if (exchange_type !== null && exchange_type !== undefined) {
            postData.exchange_type = [filter];
        }

        axios({
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            url: process.env.REACT_APP_API + '/logs/total_page_signals',
            data: postData
        }).then(res => {
            setTotalPages(res?.data?.Success);
            // props.formSubmitted(totalPages)
        }).catch(err => {
            console.log(err);
        });
    };

    const ViewLevel = (statusFilterValue, usernameValue, form_by, datefilter, exchange_type) => {
        const jwt = localStorage.getItem('jwt');

        const postData = {
            jwt: jwt,
            page_no: page,
            page_size: size,
            // username: location.pathname === '/UpdateUser' ? [userName] : [userName],
            // by: location.pathname === '/UpdateUser' || location.pathname === '/UpdateUsers' ? [profileAvatar] : ""

            // by: [profileAvatar, "User"]
        };
        if (location.pathname === '/UpdateUser' || location.pathname === '/UpdateUsers' || location.pathname === '/dashboard/activeuser' || location.pathname === '/dashboard/activeuser') {
            postData.username = [userName];
        }

        if (datefilter !== null && datefilter.length > 0) {
            postData.date = datefilter;
        }

        // if (location.pathname === '/dashboard/activeuser') {
        //     postData.pack = [FilterValue];
        // } else if (statusFilterValue !== null && statusFilterValue !== undefined) {
        //     postData.pack = [statusFilterValue];
        // }


        if (form_by !== null && form_by !== undefined) {
            postData.by = [form_by]
        }
        if (usernameValue !== null && usernameValue !== undefined) {
            if (/^\d+$/.test(usernameValue)) {
                postData.transid = [usernameValue];
            } else {
                postData.username = [usernameValue];
            }
        }

        if (exchange_type !== null && exchange_type !== undefined) {
            postData.exchange_type = [filter];
        }

        axios({
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            url: process.env.REACT_APP_API + '/logs/signals',
            data: postData
        }).then(res => {
            if (res?.data?.Success === "No transactions yet!") {
                setData([]);
            } else {
                setData(res?.data?.Success);
            }
        }).catch(err => {
            // message.error(err);
        });
    };

    useEffect(() => {
        if (userName) {
            ViewTotalLevel(statusFilterValue, UsernameFilter, gatewayFilter, dateFilter, filter, FilterValue);
            ViewLevel(statusFilterValue, UsernameFilter, gatewayFilter, dateFilter, filter, FilterValue);
        }
    }, [page, size, statusFilterValue, formSubmitted, dateFilter, FilterValue, UsernameFilter, TransidFilter, gatewayFilter, assetsFilter, filter, userName]);

    const [selectedUsername, setSelectedUsername] = useState('');
    const [selectedTransID, setSelectedTransID] = useState('');

    const exchange_Type = data.some((item) => item.Exchange_Type === "FUTURES");

    const columns = [
        {
            title: "Datetime",
            dataIndex: "DateTime",
            key: "DateTime",
            width: undefined,
            className: "whitespace-nowrap ",
        },
        {
            title: "Session ID",
            dataIndex: "SessionID",
            key: "SessionID",
            width: undefined,
            className: "whitespace-nowrap ",
        },
        {
            title: "Bot ID",
            dataIndex: "CopyTradeID",
            key: "CopyTradeID",
            width: undefined,
            className: "whitespace-nowrap ",
        },
        {
            title: 'API Name',
            dataIndex: 'API_Name',
            key: 'API_Name',
            width: undefined,
            className: "whitespace-nowrap ",
        },
        {
            title: "Symbol",
            dataIndex: "Symbol",
            key: "Symbol",
            width: undefined,
            className: "whitespace-nowrap ",
        },
        {
            title: "Exchange",
            dataIndex: "Exchange",
            key: "Exchange",
            width: undefined,
            className: "whitespace-nowrap ",
        },
        {
            title: 'Type',
            dataIndex: 'Type',
            key: 'Type',
            width: undefined,
            className: "whitespace-nowrap ",
        },
        {
            title: 'Exchange Type',
            dataIndex: 'Exchange_Type',
            key: 'Exchange_Type',
            width: undefined,
            className: "whitespace-nowrap ",
        },
        {
            title: 'Live Price',
            dataIndex: 'LivePrice',
            key: 'LivePrice',
            width: undefined,
            className: "whitespace-nowrap ",
        },
        {
            title: 'Balance',
            dataIndex: 'Balance',
            key: 'Balance',
            width: undefined,
            className: "whitespace-nowrap ",
        },
        exchange_Type && {
            title: 'Side',
            dataIndex: 'Side',
            key: 'Side',
            width: undefined,
            className: "whitespace-nowrap",
            render: (text) => {
                return text;
            },
        },
        {
            title: 'Signal',
            dataIndex: 'Signal',
            key: 'Signal',
            width: undefined,
            className: "whitespace-nowrap ",

            render: (text) => {
                return text === "Buy" ? (
                    <button
                        // onClick={() => showModal(record.Username, record.CopyTradeID)}
                        className=" text-[green] px-2 py-1 rounded-md"
                    >
                        Buy
                    </button>
                ) : (
                    <button
                        // onClick={() => showModal(record.Username, record.CopyTradeID)}
                        className=" text-[red] px-2 py-1 rounded-md"
                    >
                        Sell
                    </button>
                );
            }
        },
    ].filter(Boolean);

    const showModal = (username, transID) => {
        setEditModal(true);
        setSelectedUsername(username);
        setSelectedTransID(transID);
    };


    const [editModal, setEditModal] = useState(false);

    const handleModalClose = () => {
        setEditModal(false);
    };



    const handleLevelFilter = (value) => {
        setLevelFilter(value);
    };


    const dataSource = data.map((item, index) => ({
        Serial: index + 1,
        DateTime: item?.DateTime || '--',
        CopyTradeID: item?.CopyTradeID || '--',
        Exchange: item?.Exchange || '--',
        Exchange_Type: item?.Exchange_Type || '--',
        Symbol: item?.Symbol || '--',
        Balance: item?.Balance || '--',
        API_Name: item?.API_Name || '--',
        LivePrice: item?.LivePrice || '--',
        SessionID: item?.SessionID || '--',
        Type: item?.Type || '--',
        Executed_By: item?.Executed_By || '--',
        Side: item?.Side || '--',
    }));

    const handleSearch = (value) => {
        const searchValue = value.trim();
        switch (searchType) {
            case 1:
                setUsernameFilter(searchValue);
                setTransidFilter(null);
                setGatewayFilter(null);
                break;
            case 2:
                setUsernameFilter(null);
                setTransidFilter(searchValue);
                setGatewayFilter(null);
                break;
            case 3:
                setUsernameFilter(null);
                setTransidFilter(null);
                setGatewayFilter(searchValue);
                break;
            case 4:
                setUsernameFilter(null);
                setTransidFilter(null);
                setGatewayFilter(null);
                setdateFilter(searchValue);
                break;
            default:
                break;
        }
    };

    const onChange = e => {
        setSearchType(e.target.value);
        switch (e.target.value) {
            case 1:
                setPlaceholder('Search Username...');
                break;
            case 2:
                setPlaceholder('Search Transaction ID...');
                break;
            case 3:
                setPlaceholder('Search Executed By...');
                break;
            default:
                setPlaceholder('Search...');
        }
    };


    const prepareDataForCSV = () => {
        const csvData = Array.isArray(data) ? data.map((item, index) => ({
            Serial: index + 1,
            DateTime: item?.DateTime || '--',
            CopyTradeID: item?.CopyTradeID || '--',
            Exchange: item?.Exchange || '--',
            Exchange_Type: item?.Exchange_Type || '--',
            Symbol: item?.Symbol || '--',
            Balance: item?.Balance || '--',
            API_Name: item?.API_Name || '--',
            LivePrice: item?.LivePrice || '--',
            Username: item?.Username || '--',
            SessionID: item?.SessionID || '--',
            Type: item?.Type || '--',
            Executed_By: item?.Executed_By || '--',
            Side: item?.Side || '--',
        })) : [];

        return csvData;
    };

    const handleDateChange = (dates) => {
        if (dates && dates[0] && dates[1]) {
            const formattedDates = dates.map(date => date.toDate()).map(date => format(date, 'dd-MM-yyyy'));
            setdateFilter(formattedDates);
        } else {
            setdateFilter(null);
        }
    };

    return (

        location.pathname === '/dashboard/activeuser' || location.pathname === '/dashboard/activeuser' ? (
            <div >
                <div>
                    <div className='block md:flex gap-2 justify-between items-center my-2'>

                        <div>
                            <div className="flex justify-between items-center">
                                <div className="flex justify-start flex-col items-start lg:space-x-4 ">
                                    <div className="p-2 ">
                                        <div className="flex mb-4 items-center justify-end">

                                            <button
                                                className={`mr-2 2xl:px-4 py-1 rounded-full w-20 2xl:w-24 shadow-md ${filter === "SPOT"
                                                    ? "bg-colorSecondaryDark text-white border-2 border-white drop-shadow-xl"
                                                    : "bg-white text-colorSecondaryDark"
                                                    }`}
                                                onClick={() => {
                                                    handleFilterClick("SPOT");
                                                    setFilter("SPOT");
                                                }}
                                            >
                                                Spot
                                            </button>
                                            <button
                                                className={`mr-2 xl:px-4 py-1 rounded-full w-20 2xl:w-24 shadow-md ${filter === "FUTURES"
                                                    ? "bg-colorSecondaryDark text-white border-2 border-white drop-shadow-xl"
                                                    : "bg-white text-colorSecondaryDark"
                                                    }`}
                                                onClick={() => {
                                                    handleFilterClick("FUTURES");
                                                    setFilter("FUTURES");
                                                }}
                                            >
                                                Futures
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <RangePicker format={'DD-MM-YYYY'}
                            onChange={handleDateChange} /> */}


                        <div className='flex justify-end gap-5 items-center'>

                            <div className=''>
                                <Button className='bg-colorAccent text-white px-4  font-semibold rounded-lg' >
                                    <CSVLink
                                        data={prepareDataForCSV()}
                                        filename={'user_data.csv'}
                                        className="text-white"
                                    >
                                        Download CSV
                                    </CSVLink>
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    {/* <Model
                        title="Expiry Subscription"
                        open={editModal}
                        onCancel={handleModalClose}
                        onFinish={handleApproveReject}
                        label2="2FA"
                        name2="totp"
                        placeholder2="Enter 2FA"
                        message2="Please input your 2FA!"
                    /> */}
                </div>
                <NewTransactionTable data={data} handleSearch={handleSearch} prepareDataForCSV={prepareDataForCSV} onSearch={handleSearch} setData={setData} onLevelChange={handleLevelFilter} columns={columns} dataSource={dataSource} totalPages={totalPages} page={page} size={size} setPage={setPage} setSize={setSize} />
            </div>
        ) : (
            <>
                <div className='mx-0 md:mx-4 bg-white shadow-md shadow-black rounded-xl p-2  md:p-4 '>

                    <div>
                        <div className='block md:flex justify-between items-center my-2'>

                            <Radio.Group onChange={onChange} value={searchType} className='flex justify-center items'>
                                <Radio value={1} className='text-xs md:text-base'>Username</Radio>
                                <Radio value={2} className='text-xs md:text-base'>TransID</Radio>
                                <Radio value={3} className='text-xs md:text-base'>Executed By</Radio>
                            </Radio.Group>

                            <Search className=' md:w-96 my-2 md:my-0' placeholder={placeholder}
                                onSearch={handleSearch} enterButton />
                            <div>
                                <div className="flex justify-between items-center">
                                    <div className="flex justify-start flex-col items-start lg:space-x-4 ">
                                        <div className="p-2 ">
                                            <div className="flex mb-4 items-center justify-end">

                                                <button
                                                    className={`mr-2 2xl:px-4 py-1 rounded-full w-20 2xl:w-24 shadow-md ${filter === "SPOT"
                                                        ? "bg-colorSecondaryDark text-white border-2 border-white drop-shadow-xl"
                                                        : "bg-white text-colorSecondaryDark"
                                                        }`}
                                                    onClick={() => {
                                                        handleFilterClick("SPOT");
                                                        setFilter("SPOT");
                                                    }}
                                                >
                                                    Spot
                                                </button>
                                                <button
                                                    className={`mr-2 xl:px-4 py-1 rounded-full w-20 2xl:w-24 shadow-md ${filter === "FUTURES"
                                                        ? "bg-colorSecondaryDark text-white border-2 border-white drop-shadow-xl"
                                                        : "bg-white text-colorSecondaryDark"
                                                        }`}
                                                    onClick={() => {
                                                        handleFilterClick("FUTURES");
                                                        setFilter("FUTURES");
                                                    }}
                                                >
                                                    Futures
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <RangePicker format={'DD-MM-YYYY'}
                                onChange={handleDateChange} /> */}
                            <div className='flex justify-end gap-5 items-center'>
                                <div className=''>
                                    <Button className='bg-colorAccent text-white px-4  font-semibold rounded-lg' >
                                        <CSVLink
                                            data={prepareDataForCSV()}
                                            filename={'user_data.csv'}
                                            className="text-white"
                                        >
                                            Download CSV
                                        </CSVLink>
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>

                    </div>
                    <NewTransactionTable data={data} handleSearch={handleSearch} prepareDataForCSV={prepareDataForCSV} onSearch={handleSearch} setData={setData} onLevelChange={handleLevelFilter} columns={columns} dataSource={dataSource} totalPages={totalPages} page={page} size={size} setPage={setPage} setSize={setSize} />
                </div>
                {/* <Model
                    title="Expiry Subscription"
                    open={editModal}
                    onCancel={handleModalClose}
                    onFinish={handleApproveReject}
                    label2="2FA"
                    name2="totp"
                    placeholder2="Enter 2FA"
                    message2="Please input your 2FA!"
                /> */}
            </>


        )
    );

}

export default LogsTable;
